import React from 'react'
import '../style/home.css'
import Footer from './Footer'
import '../style/about.css'

export default function Home() {
  return (
    <div className='home-container'>
      <div className='home-hero-wrap'>
        {/* <img src='/minis-1.jpg'/> */}
        <img src='https://pub-2442ae11dbb94470b7be6af2450ed329.r2.dev/church-banner-1400x.gif'/>
        <div className='home-hero-txt montserrat'>
          JOIN THE CHURCH
        </div>
      </div>
      <div className='section-container'>
        <div className='three-img-row-sec'>
          <div className='img-row-sec-item'>
            <div className='home-sec-img-container'>
              <img src='/wow-media-1.jpg'/>
              <h3 className='img-row-txt montserrat'>
                {/* TXT PLACEHOLDER */}
                To Learn
              </h3>
            </div>
          </div>
          <div className='img-row-sec-item'>
            <div className='home-sec-img-container'>
              <img src='/children-media-1.jpg'/>
              <h3 className='img-row-txt montserrat'>
                {/* PLACEHOLDER TXT */}
                To Grow
              </h3>
            </div>
          </div>
          <div className='img-row-sec-item'>
            <div className='home-sec-img-container'>
              <img src='/wow-media-2.jpg'/>
              <h3 className='img-row-txt montserrat'>
                 {/* TXT PLACEHOLDER */}
                 To Fellowship
              </h3>
            </div>
          </div>
        </div>
        <div className='quote-container quote-container-1'>
          <q>
            One God. One language. One desire and adoration- to praise and worship Him, in spirit and in truth.
          </q>
        </div>
        <div className="media-lg-content-container">
          <div className="media-container">
            <img src="/church-banner.jpg" alt="" />
          </div>
          <div>
           <p 
            className="caption-title" 
            style={{ fontSize: '18px', marginBottom: '0.3em' }}
            >Grow with us</p>
            <h2>Service Times:</h2>
            <ul className="service-list-time ">
                <li>9:30 AM Sunday School</li>
                <li>10:30 AM Sunday Worship Service</li>
                <li>11:00 AM Children Sunday School</li>
                <li>6:00 PM  Tuesday Youth and & Young Adults Bible Study</li>
                <li>
                  7:00 PM Wednesday Bible Study  <br/>
                  <a href="https://us02web.zoom.us/j/81294113080?pwd=eUNkc0g3SXpYZm9zQmxMdmx6Q3JZZz09" target=
                  "_blank" style={{ color: '#c59a8e' }}>Join Us on Zoom</a>
                </li>
                <li>
                  7:00 PM Friday Bible Study <br/>
                  <a href="https://us02web.zoom.us/j/81184961735?pwd=N1luTUFYajJlKzh6L0k5T3FxRVp6QT09" target=
                  "_blank" style={{ color: '#c59a8e' }}>Join Us on Zoom</a>
                </li>
             </ul>
          </div>
        </div>
      </div>
      {/*<Footer />*/}
    </div>
  )
}